import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Root from "./root";
import apiRequest from 'utils/apiRequest';
import { INITIAL_DATA } from 'apis';
import { actionLogOutUser, handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { handleChangeDataInitialData } from 'reduxx/actions/partials/data';


const App = () => {
	
	const dispatch = useDispatch();

	const { token } = useSelector((state: any) => state.login);

	useEffect(() => {
        handleCheckedLoginAndOtherData();
    }, [App]);


    const handleCheckedLoginAndOtherData = () => {

    	apiRequest({
		    dispatch,
		    endpoint: INITIAL_DATA,
		    method: 'post',
            data: {width: window.innerWidth},
		    token: token,
		    onSuccess: (res) => {
		    	dispatch(handleChangeDataInitialData('insurances', res.insurances));

                if(res.userInfo !== null)
                	dispatch(handleChangeProfileData(res.userInfo));
                else
                	dispatch(actionLogOutUser());
		    },
	  	});

    };


	return (
        <div id={'app'} className={'rtl'}>
            <Root/>
        </div>
    )
}

export default memo(App);
